import React from 'react';
import { Route } from 'react-router-dom';
import { PAGE_ROUTES } from './multilingualRoutes';

export function generateMultilingualRoutes(componentMap: Record<string, React.ComponentType<any>>) {
  const routes: JSX.Element[] = [];

  Object.entries(PAGE_ROUTES).forEach(([pageKey, pageData]) => {
    const Component = componentMap[pageData.component];

    if (!Component) {
      console.warn(`Component ${pageData.component} not found for page ${pageKey}`);
      return;
    }

    Object.entries(pageData.routes).forEach(([lang, path]) => {
      routes.push(
        <Route
          key={`${pageKey}-${lang}`}
          path={path}
          component={Component}
        />
      );
    });
  });

  return routes;
}
